import { Main } from "../../components";

export const Contratos = () => {
  return (
    <Main>
      <section id="publications" className="services">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Contratos</h2>
          </div>

          <div className="row mb-4">
            <div
              className="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1A4r_JTHBm56ZiEEyZOFpyBLjT47R6S3_/view"
                rel="noreferrer"
              >
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img
                      className="pdf-icon"
                      src="/assets/img/pdf-icon.png"
                      alt=""
                    />
                  </div>
                  <h4>Contrato de Patrocínio CBMM - Proj. Taekwondo em Ação</h4>
                </div>
              </a>
            </div>
            <div
              className="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1Onl7tSZZCbRRtapLRzEZkTCRs82g--7I"
                rel="noreferrer"
              >
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img
                      className="pdf-icon"
                      src="/assets/img/pdf-icon.png"
                      alt=""
                    />
                  </div>
                  <h4>Contrato de Patrocínio CBMM - Proj. Taekwondo Transformação II</h4>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Main>
  );
};
